
























import Translation from '@/mixins/Translation'
import Assets from '@/mixins/Assets'
import BttPopup from '@/components/popup/btt/BttPopup.vue'
import FooterButton from '@/components/popup/btt/FooterButton.vue'
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import toDateKor from '@/filters/to-date-kor'
import toHalfKor from '@/filters/to-half-kor'

@Component({
  components: {BttPopup, FooterButton},
  filters: {toDateKor, toHalfKor},
})
export default class TaxRNumInfoPopup extends Mixins(Translation, Assets) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: false, type: Boolean}) value: boolean
  @Prop({default: 'biz-info', type: String}) type: 'biz-info' | 'client'

  open: boolean = true

  @Watch('value', {immediate: true})
  __value(value) {
    this.open = value
  }

  onHandlePopup(value) {
    this.$emit('input', value)
  }
}
